module.exports = __webpack_public_path__ + "img/Cagliari.713c478e.png";